import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	categoryPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import type {ICategory} from '../schema';

export const canDeleteCategory = (category?: ICategory): boolean => {
	if (category == null) return false;
	if (isBrandPortal()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
	return categoryPermissionChecker({
		category,
		permissionMatrixName: PermissionMatrixName.DELETE,
		permissionName: PermissionName.DELETE_FOLDERS,
	});
};
